import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/es6/number';
import 'core-js/es6/array';
import 'core-js/es6/promise';
import 'core-js/es6/object';
import 'core-js/fn/array/find-index';
import 'core-js/fn/array/includes';

import { runWithAdal } from 'react-adal';
import { authContext } from './config/adalConfig';

const DO_NOT_LOGIN = true;

runWithAdal(authContext, () => {
    // eslint-disable-next-line
    require('./indexApp.js');
}, DO_NOT_LOGIN);



// WEBPACK FOOTER //
// ./src/index.js